import React, { useState, useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Topbar } from "./Components/HeaerAndFooter/Topbar";
import { Home } from "./Screens/Home";
import { Footer } from "./Components/HeaerAndFooter/Footer";
import { Coffee } from "./Screens/Coffee";
import { Subscription } from "./Screens/Subscription";
import { Aboutus } from "./Screens/Aboutus";
import { Contactus } from "./Screens/Contactus";
import { Supporting } from "./Screens/Supporting";
import { Checkout } from "./Screens/Checkout";
import { Payment } from "./Screens/Payment";
import Login from "./Screens/Login";
import Register from "./Screens/Register";
import { ToastContainer } from "react-toastify";
import { Draft } from "./Screens/Draft";
import { AllDraft } from "./Screens/AllDraft";
import { CartPayment } from "./Screens/CartPayment";
import useScrollRestoration from "./Components/ScrollComp/useScrollRestoration";
import ScrollToTop from "./Components/ScrollComp/ScrollToTop";
import ChatSupport from "./Components/HeaerAndFooter/ChatSupport";
import ChatBot from "./Components/HeaerAndFooter/ChatBot";
import PrivacyPloicy from "./Screens/PrivacyPloicy";
import TermsAndCondition from "./Screens/TermsAndCondition";
import ForgetPassword from "./Components/ForgetPassword/Main";
import VerifyOtp from "./Components/ForgetPassword/VerifyOtp";
import NewPassword from "./Components/ForgetPassword/NewPassword";
import VerifyUserOtp from "./Components/ForgetPassword/VerifyUserOtp";
import Profile from "./Screens/Profile";
import ChangePassword from "./Screens/ChangePassword";

function App() {
  useScrollRestoration(); // Use the custom hook
  const userId = sessionStorage.getItem("userId");

  return (
    <div className="App bg-banner">
      <ToastContainer
				position="top-right"
				autoClose={2000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
			/>
      <Topbar />
      <ScrollToTop/>
      <Routes>
        <>
          <Route path="/" element={<Home />} />
          <Route path="/coffee/:id" element={<Coffee />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/draft/:id" element={<Draft />} />
          <Route path="/all-draft/:id" element={<AllDraft />} />
          <Route path="/about-us" element={<Aboutus />} />
          <Route path="/contact-us" element={<Contactus />} />
          <Route path="/supporting-veterans" element={<Supporting />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/payment/:id" element={<Payment />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/cart-payment/:id" element={<CartPayment />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/privacy-policy" element={<PrivacyPloicy />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/verify-otp/:email" element={<VerifyOtp />} />
          <Route path="/verify-user-otp/:email" element={<VerifyUserOtp />} />
          <Route path="/new-password/:email" element={<NewPassword />} />
          <Route path="/terms-and-conditions" element={<TermsAndCondition />} />
        </>
      </Routes>
      <ChatSupport/>
      {/* <ChatBot/> */}
      <Footer />
    </div>
  );
}

export default App;
